// extracted by mini-css-extract-plugin
export default {"item":"item_item__qIV3u","itemSelecionado":"item_itemSelecionado__5hDn9","itemCompletado":"item_itemCompletado__ym5OZ","concluido":"item_concluido__TMWnL"};